<div class="page">
  <app-page-header page-title="genericDocs.list.pageTitle"></app-page-header>
  <div class="page-content">

    <mat-card class="custom-card">
      <mat-card-title>{{ 'genericDocs.list.listTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.listTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
          <div class="mt-2 mb-4">
            <button class="add-icon-button mr-2" color="primary" (click)="onAddDoc()" mat-flat-button
              matTooltip="{{ 'common.cta.add' | translate }}" matTooltipPosition="above">
              <mat-icon fontSet="fal" fontIcon="fa-qrcode"></mat-icon> {{ 'common.cta.add' | translate }}
            </button>
            <!-- 
            <div class="float-right" *ngIf="loggedUserRole?.type === 'master' || loggedUserRole?.type === 'collaborator'">
              <strong>{{ 'genericDocs.list.maxSpaceAvailable' | translate: { occupiedSpace: occupiedSpace }  }}</strong>
            </div>
            -->
          </div>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                  <!-- <mat-form-field>
                    <input matInput placeholder="{{ 'common.words.search' | translate }}" #input>
                    <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="resetInput()"
                      class="reset-input-icon" *ngIf="input.value"></mat-icon>
                  </mat-form-field> -->
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onExport()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onResetFilters()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="spinner-container" *ngIf="dataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="dataSource" matSort #sort1="matSort" matSortActive="createdAt" 
                matSortDirection="desc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-30">
                    {{ 'genericDocs.fields.name' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.name }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter" >
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="nameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(nameFilter)"
                        class="reset-input-icon ml-n3" *ngIf="nameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'genericDocs.fields.description' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.description }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="descriptionFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(descriptionFilter)"
                        class="reset-input-icon" *ngIf="descriptionFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header  class="col-width col-width-20">
                    {{ 'genericDocs.fields.createdAt' | translate }}</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.createdAt | dateFormat }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="createdAtFilter"
                        style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(createdAtFilter)"
                        class="reset-input-icon" *ngIf="createdAtFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="text-right pr-5" class="col-width col-width-10">
                    {{ 'common.cta.actions' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-right">
                    <button [matMenuTriggerFor]="listsMenu" mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-chevron-down"></mat-icon>
                    </button>
                    <mat-menu #listsMenu="matMenu" [hasBackdrop]="true">
                      <button mat-menu-item (click)="onEdit(element)">{{ 'genericDocs.list.modify' | translate }}</button>
                      <button mat-menu-item (click)="onDelete(element._id)">{{ 'genericDocs.list.delete' | translate }}</button>
                      <button mat-menu-item (click)="onDownload(element)">{{ 'common.cta.downloadFile' | translate }}</button>
                      <button mat-menu-item (click)="onViewQrcode(element)">{{ 'genericDocs.list.qrcode' | translate }}</button>
                      <button mat-menu-item (click)="onPrintQrcode(element)">{{ 'genericDocs.list.printQrcode' | translate }}</button>
                    </mat-menu>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
              </table>
              <mat-paginator [length]="dataSource.totalCount$ | async" [pageSizeOptions]="[10, 15, 20, 50, 75, 100]"
                showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>
  </div> <!-- /.page-content -->
</div> <!-- /.page -->